import React, { useEffect, useState } from 'react'
import InputTable from './InputTable'
import { simularCupos, restoreCumplimiento } from '../../actions/listados'
import { formValueSelector, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { IconButton, Tooltip } from '@material-ui/core'
import UndoIcon from '@material-ui/icons/Undo'

const MAX = 100

function EstimacionCumplimiento (props) {
  const { cumplimientoCupo, cuposProyectados, cereal, fecha, cumplimiento, change: formChange, simularCupos } = props
  const [porcentaje, setProcentaje] = useState(cumplimientoCupo)

  useEffect(() => {
    setProcentaje(cumplimientoCupo)
  }, [cumplimientoCupo])

  const handleDisplay = () => {
    formChange('cumplimiento', cumplimientoCupo)
  }

  const handleBlur = () => {
    if (!cumplimiento) {
      formChange('cumplimiento', cumplimientoCupo)
    } else if (cumplimientoCupo !== cumplimiento && cumplimiento <= MAX) {
      setProcentaje(cumplimiento)
      simularCupos(fecha, cereal, cuposProyectados, cumplimiento)
    }
  }

  const handleReset = () => {
    props.restoreCumplimiento(cereal)
    formChange('cumplimientoRestore', '')
  }

  const handleBlurRestore = () => {
    const { cumplimientoRestore } = props
    props.restoreCumplimiento(cereal, cumplimientoRestore)
    formChange('cumplimientoRestore', '')
  }

  const handleDisplayRestore = () => {
    formChange('cumplimientoRestore', '')
  }

  const renderCumplimientoInput = () => {
    if (cumplimientoCupo === 'CONFIG' && cereal !== 'TODOS') {
      // Si el cumplimiento es 'CONFIG' y no esta mostrando todos los cereales --> botón de reset
      // para restablecer el valor para todos los días con el cumplimiento inicial (por cereal)
      return (
        <>
          <Tooltip title={'Aplicar cumplimiento por cereal'}>
            <InputTable
              style={{ padding: 0, color: 'white' }}
              name='cumplimientoRestore'
              icono={null}
              value={'Aplicar %'}
              handleDisplay={handleDisplayRestore}
              handleBlur={handleBlurRestore}
              colorValue={'white'}
            />
          </Tooltip>

          <Tooltip title={'Restablecer cumplimiento'}>
            <IconButton
              style={{ outline: 'none' }}
              onClick={handleReset}
            >
              <UndoIcon fontSize='small' style={{ color: 'white' }} />
            </IconButton>
          </Tooltip>
        </>
      )
    }

    // Si esta activo el modo visualizacion, muestra el componente de entrada para simular solo cumplimiento
    if (cumplimientoCupo !== 'CONFIG' && cereal !== 'TODOS') {
      return (
        <InputTable
          name='cumplimiento'
          icono={'%'}
          value={porcentaje}
          handleDisplay={handleDisplay}
          handleBlur={handleBlur}
          max={MAX}
        />
      )
    }

    if (cereal === 'TODOS') {
      return <> {porcentaje} %</>
    }

    return <> - </>
  }

  return (
    renderCumplimientoInput()
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state) => ({
  cumplimiento: selector(state, 'cumplimiento'),
  cumplimientoRestore: selector(state, 'cumplimientoRestore'),
  // isSimulacion: state.stock.isSimulacion,
  exportador: selector(state, 'exportadorProyeccion')
})

const mapActionsToProps = {
  restoreCumplimiento,
  simularCupos
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(EstimacionCumplimiento))
